import type { BboxItem } from '../../store/useExtractionStore';

/** Parse content_bbox which can be a plain [x,y,x,y] array or {type, bbox} object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseBboxCoords(raw: any): [number, number, number, number] | null {
  if (!raw) return null;
  if (Array.isArray(raw) && raw.length >= 4) return raw as [number, number, number, number];
  if (raw.bbox && Array.isArray(raw.bbox)) return raw.bbox;
  return null;
}

/** Parse context_blocks which use block_type (backend) or type (frontend) */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseContextBlocks(blocks: any[], idRef: React.MutableRefObject<number>): BboxItem[] {
  if (!Array.isArray(blocks)) return [];
  const items: BboxItem[] = [];
  for (const b of blocks) {
    const bbox = parseBboxCoords(b.bbox || b);
    if (!bbox) continue;
    items.push({
      id: `b-${idRef.current++}`,
      type: b.block_type || b.type || 'context',
      bbox,
      label: b.label || b.block_type || b.type,
    });
  }
  return items;
}
